import React, {PureComponent, PropTypes} from 'react';
import Modal from 'react-modal';
import cx from 'classnames';
import axios from 'axios';
import Autosuggest from 'react-autosuggest';

import style from './invite.module.css';
import autoSuggestTheme from './autosuggest.module.css';
import modalStyle from '../modal.module.css';

class TeamMemberSelect extends PureComponent {

    static propTypes = {
        onClose: PropTypes.func,
        submitUrl: PropTypes.string,
        open: PropTypes.bool,
        init: PropTypes.bool,
        teamId: PropTypes.number,
        tournamentId: PropTypes.number,
        title: PropTypes.string,
        image: PropTypes.string
    };

    constructor() {
        super();

        this.state = {
            value: '',
            suggestions: []
        };
    }

    _submitForm = (e) => {
        e.preventDefault();

        const title = this.state.value;

        if (!title) {
            return this.setState({
                error: Exanimo.trans('missing_title'),
                success: false
            });
        }

        this.setState({
            loading: true
        });

        fetch(this.props.submitUrl || '/teams/invite', {
            credentials: 'same-origin',
            method: 'post',
            body: JSON.stringify({
                team_id: this.props.teamId,
                tournament_id: this.props.tournamentId,
                username: title
            }),
            headers:{'X-CSRF-TOKEN': Exanimo.CSRF}
        }).then((response) => {

            if (response.status !== 200) {
                throw new Error(Exanimo.trans('request_failed'));
            }

            return response.json();
        }).then((data) => {
            if (data.ok) {
                this.setState({
                    success: true,
                    error: '',
                    loading: false
                });
            } else {
                throw new Error(data.error);
            }
        }).catch((err) => {
            this.setState({
                loading: false,
                error: err.message,
                success: false
            });
        });
    }

    static getSuggestionValue(suggestion) {
        return suggestion.name + '';
    }

    static renderSuggestion(suggestion) {
        return (
            <div>
                <img className={autoSuggestTheme.avatar} src={suggestion.image} />
                <div className={autoSuggestTheme.title}>{suggestion.name}</div>
            </div>
        );
    }

    onSuggestionsClearRequested = () => {
        this.setState({
            suggestions: []
        });
    };

    componentWillReceiveProps(props) {
        if (props.init) {
            this._resetState();
        }
    }

    _resetState() {
        this.setState({
            error: '',
            loading: false,
            success: false,
            suggestions: []
        });
    }

    loadSuggestions = (value) => {

        if (this.lastRequest) {
            this.lastRequest.cancel();
        }

        if (value.value.length <= 2) {
            return;
        }

        this.setState({
            suggestionLoading: true
        });

        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();

        axios.get(`/profile/search?search=${value.value}`, {
            cancelToken: source.token
        }).then((response) => {
            this.setState({
                suggestionLoading: false,
                suggestions: response.data
            });
        }).catch(function(thrown) {
            if (axios.isCancel(thrown)) {
                console.log('Request canceled', thrown.message);
            }
        });
        
        this.lastRequest = source;
    }

    onChange = (event, { newValue }) => {
        this.setState({
            value: newValue
        });
    };

    render() {

        const customStyles = {
            overlay : {
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                zIndex: 2
            },
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                backgroundColor       : '#F1F1F1',
                color                 : '#333333',
                padding               : '0',
                overflow              : 'visible'
            }
        };

        const error = (this.state.error) ? <div className={modalStyle.error}>{this.state.error}</div> : '';
        const success = (this.state.success) ? <div className={modalStyle.success}>{Exanimo.trans('invite_success')}</div> : '';
        const saveButtonText = (this.state.loading) ? '. . .' :  Exanimo.trans('save');
        const buttonClasses = cx(modalStyle.button, style.button);

        const inputProps = {
            value: this.state.value,
            onChange: this.onChange
        };

        return (
            <Modal
                isOpen={this.props.open}
                onRequestClose={this.props.onClose}
                contentLabel="Invite"
                style={customStyles}
            >
                <div className={style.container}>
                    <a href="" onClick={this.props.onClose} className={modalStyle.close}/>

                    <div className={style.content}>
                        <form onSubmit={this._submitForm}>
                            {error}
                            {success}
                            <p className={modalStyle.subtitle}>{Exanimo.trans('username')} <span className={modalStyle.required}>*</span></p>

                            <Autosuggest
                                suggestions={this.state.suggestions}
                                onSuggestionsFetchRequested={this.loadSuggestions}
                                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                                getSuggestionValue={TeamMemberSelect.getSuggestionValue}
                                renderSuggestion={TeamMemberSelect.renderSuggestion}
                                inputProps={inputProps}
                                theme={autoSuggestTheme}
                            />

                            <div className={style.actionContainer}>
                                <a onClick={this._submitForm} className={buttonClasses}>{saveButtonText}</a>
                            </div>
                        </form>
                    </div>
                </div>
            </Modal>);
    }
}

export default TeamMemberSelect;